function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { computed } from "mobx";
import Result from "../../Core/Result";
import TerriaError from "../../Core/TerriaError";
import createStratumInstance from "../../Models/Definition/createStratumInstance";
import saveStratumToJson from "../../Models/Definition/saveStratumToJson";
import NestedStrataMap from "../NestedStrataMap";
import Trait from "../Trait";
import traitsClassToModelClass from "../traitsClassToModelClass";
export default function objectTrait(options) {
  return function (target, propertyKey) {
    const constructor = target.constructor;
    if (!constructor.traits) {
      constructor.traits = {};
    }
    constructor.traits[propertyKey] = new ObjectTrait(propertyKey, options, constructor);
  };
}
export class ObjectTrait extends Trait {
  constructor(id, options, parent) {
    super(id, options, parent);
    _defineProperty(this, "type", void 0);
    _defineProperty(this, "isNullable", void 0);
    _defineProperty(this, "decoratorForFlattened", computed.struct);
    _defineProperty(this, "modelClass", void 0);
    this.type = options.type;
    this.isNullable = options.isNullable || false;
    this.modelClass = options.modelClass || traitsClassToModelClass(this.type);
  }
  getValue(model) {
    return new this.modelClass(undefined, model.terria, undefined, new NestedStrataMap(model.TraitsClass, model.strata, this.id));
  }
  fromJson(model, stratumName, jsonValue) {
    const ResultType = this.type;
    const result = createStratumInstance(ResultType);
    if (this.isNullable && jsonValue === null) {
      return new Result(jsonValue);
    }
    const errors = [];
    Object.keys(jsonValue).forEach(propertyName => {
      const trait = ResultType.traits[propertyName];
      if (trait === undefined) {
        errors.push(new TerriaError({
          title: "Unknown property",
          message: "".concat(propertyName, " is not a valid sub-property of ").concat(this.id, ".")
        }));
        return;
      }
      const subJsonValue = jsonValue[propertyName];
      if (subJsonValue === undefined) {
        result[propertyName] = undefined;
      } else {
        result[propertyName] = trait.fromJson(model, stratumName, subJsonValue).pushErrorTo(errors);
      }
    });
    return new Result(result, TerriaError.combine(errors, "Error".concat(errors.length !== 1 ? "s" : "", " occurred while updating objectTrait model \"").concat(model.uniqueId, "\" from JSON")));
  }
  toJson(value) {
    if (value === undefined) {
      return undefined;
    }
    return saveStratumToJson(this.type.traits, value);
  }
  isSameType(trait) {
    return trait instanceof ObjectTrait && trait.type === this.type && trait.isNullable === this.isNullable;
  }
}